import api from './axiosInstance';
export const getAll = (params) => api.get('/accessory-groups', { params });
export const getById = (id) => api.get(`/accessory-groups/${id}`);
export const create = (data) => api.post('/accessory-groups', data);
export const update = (id, data) => api.put(`/accessory-groups/${id}`, data);
export const remove = (id) => api.delete(`/accessory-groups/${id}`);
export const batchRemove = (ids) => api.post('/accessory-groups/batch-delete', { ids });
